import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface VideoFileState {
  status: 'idle' | 'added' | 'uploading' | 'processing' | 'uploaded' | 'error';
  name: string | null;
  percent: number;
  duration: number | null;
}

export const videoFileInitialState: VideoFileState = {
  status: 'idle',
  name: null,
  percent: 0,
  duration: null,
};

export const videoFileSlice = createSlice({
  name: 'videoFile',
  initialState: videoFileInitialState,
  reducers: {
    updateFile(state, action: PayloadAction<Partial<VideoFileState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const videoFileReducer = videoFileSlice.reducer;

export const { updateFile } = videoFileSlice.actions;
